import $ from "jquery";
import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { parse } from "query-string";
import Breadcrumbs from "./Breadcrumbs";
import Product from "../models/Product";

let instance;

export default class Page {
  static getInstance() {
    if (!instance) {
      instance = new Page(window.location);
    }
    return instance;
  }

  constructor(location) {
    this.breadcrumbs = new Breadcrumbs();
    this.location = location;

    GlamCornerCore.bus.on(MainWebsiteEvents.RedirectPage, {}, ({ url }) => {
      window.location.assign(url);
    });
  }

  isCataloguePage() {
    return $(".js-catalog-header").length > 0;
  }

  isSplashPage() {
    return $(".attributesplash-page-view").length > 0;
  }

  searchTerm() {
    const pathname = this.location.pathname;
    const search = this.location.search;
    if (pathname === "/catalogsearch/result" && search.indexOf("q=") !== -1) {
      return parse(search.replace(/^\?/, "")).q;
    } else {
      return null;
    }
  }

  isProductPage() {
    return !!this.location.pathname.match(/^\/designers\/[^\/]+\/[^\/]+/);
  }

  isOnDemandProductPage() {
    return this.isProductPage() && this.location.search.indexOf("subscription") === -1;
  }

  product() {
    return window._gc_product && Product.fromDocumentProductData(window._gc_product);
  }

  redirectToSubscriptionProductPage() {
    if (this.isOnDemandProductPage()) {
      this.location.search = "?subscription";
    }
  }
}
